<template>
    <button
        :type="nativeType"
        :form="form || null"
        class="app-dialog-action self-stretch !rounded-none border-0"
        :class="resolvedVariantClass"
        :disabled="disabled || loading"
        @click="$emit('click')"
    >
        <slot>{{ loading ? loadingLabel : label }}</slot>
    </button>
</template>

<script>
const VARIANT_CLASSES = {
    primary: 'btn-stage-primary',
    danger: 'btn-stage-danger',
    neutral: 'btn-stage-secondary',
};

export default {
    name: 'app-dialog-action',
    props: {
        label: {type: String, default: ''},
        loadingLabel: {type: String, default: 'Wird gespeichert …'},
        variant: {
            type: String,
            default: 'primary',
            validator: (value) => Object.prototype.hasOwnProperty.call(VARIANT_CLASSES, value),
        },
        disabled: {type: Boolean, default: false},
        loading: {type: Boolean, default: false},
        nativeType: {
            type: String,
            default: 'button',
            validator: (value) => ['button', 'submit', 'reset'].includes(value),
        },
        form: {type: String, default: ''},
    },
    emits: ['click'],
    computed: {
        resolvedVariantClass() {
            return VARIANT_CLASSES[this.variant] || VARIANT_CLASSES.primary;
        },
    },
};
</script>
